var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3941 25.1023L36.3884 17.8771C37.0879 17.2344 37.5542 16.1634 36.8547 15.3065C36.1553 14.4497 34.9895 14.2355 34.0568 14.6639L24.2283 21.4607L13.6179 14.665C12.6853 14.0224 11.2863 14.4508 10.82 15.3076C10.1205 16.1645 10.5868 17.2355 11.5195 17.8782L23.0625 25.1023C23.5288 25.3165 23.7619 25.3165 24.2283 25.3165C24.6946 25.3165 25.1609 25.3165 25.3941 25.1023Z",
    fill: "#DED2CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.5C5.79086 8.5 4 10.2909 4 12.5V36.5C4 38.7091 5.79086 40.5 8 40.5H40C42.2091 40.5 44 38.7091 44 36.5V12.5C44 10.2909 42.2091 8.5 40 8.5H8ZM9 12.5C8.44772 12.5 8 12.9477 8 13.5V35.5C8 36.0523 8.44772 36.5 9 36.5H39C39.5523 36.5 40 36.0523 40 35.5V13.5C40 12.9477 39.5523 12.5 39 12.5H9Z",
    fill: "#DED2CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOutlined);
export default __webpack_public_path__ + "static/media/email_outlined.2c012bb5372d73f2e332b4ee89c8260b.svg";
export { ForwardRef as ReactComponent };